import React, { useState, useCallback, useEffect } from 'react'
import Switch2 from '../../Switch/Switch'
import submissionAnalysisPromptsModule from './SubmissionAnalysisPromptsComponent.module.scss'
import { _gpt_model } from '../../../localConstant'
import { collection, getDocs, updateDoc, addDoc, deleteDoc } from 'firebase/firestore'
import { db } from '../../../firebase'
import AddCircleIcon from '@mui/icons-material/AddCircle'

function SubmissionAnalysisPromptsComponent() {
  const [submissionAnalysisPrompts, setSubmissionAnalysisPrompts] = useState([])
  const defaultModel = _gpt_model.find((gpt) => gpt.value === 'azure-gpt-4o')
  const submissionAnalysisPromptsCollectionRef = collection(db, '/submissionAnalysisPrompts')

  useEffect(() => {
    ;(async () => {
      const submissionAnalysisPromptsSnapshot = await getDocs(submissionAnalysisPromptsCollectionRef)
      const submissionAnalysisPromptsDocs = submissionAnalysisPromptsSnapshot.docs.map((doc) => {
        return { ...doc.data(), ref: doc.ref }
      })
      console.log('submissionAnalysisPromptsDocs', submissionAnalysisPromptsDocs)
      setSubmissionAnalysisPrompts(submissionAnalysisPromptsDocs)
    })()
  }, [])

  const addSubmissionAnalysisPrompt = () => {
    setSubmissionAnalysisPrompts((prev) => [
      ...prev,
      {
        buttonTitle: '',
        model: defaultModel,
        prompt: '',
        active: true
      }
    ])
  }

  const saveSubmissionAnalysisPrompt = (submissionAnalysisPrompt) => {
    if (submissionAnalysisPrompt.hasOwnProperty('ref')) {
      updateDoc(submissionAnalysisPrompt.ref, { ...submissionAnalysisPrompt })
    } else {
      addDoc(submissionAnalysisPromptsCollectionRef, { ...submissionAnalysisPrompt })
    }
    alert('保存されました。')
  }

  const deleteSubmissionAnalysisPrompt = (submissionAnalysisPrompt, index) => {
    if (submissionAnalysisPrompt.hasOwnProperty('ref')) {
      deleteDoc(submissionAnalysisPrompt.ref)
    }
    setSubmissionAnalysisPrompts(
      (prev) => prev.filter((_, i) => i !== index) // index番目の要素を除外
    )
    alert('削除されました。')
  }

  const changeSubmissionAnalysisPrompts = (updates, index) => {
    setSubmissionAnalysisPrompts((prev) => prev.map((item, i) => (i === index ? { ...item, ...updates } : item)))
  }

  return (
    <div className={submissionAnalysisPromptsModule.main}>
      <div className={submissionAnalysisPromptsModule['prompt-body-header']}>
        <div className={submissionAnalysisPromptsModule['sub-title-container']}>
          <h3 className={submissionAnalysisPromptsModule['sub-title']}>提出チャット分析プロンプトの設定</h3>
        </div>
      </div>
      <div className={submissionAnalysisPromptsModule['prompt-body']}>
        <div className={submissionAnalysisPromptsModule['search-container']}>
          <p className={submissionAnalysisPromptsModule.tips}>
            {'※ ${submission_data_for_analysis}に分析するデータが入ります。'}
          </p>
        </div>

        <div className={submissionAnalysisPromptsModule['doc-list']}>
          <table className={submissionAnalysisPromptsModule['table']}>
            <thead>
              <tr>
                <th className={submissionAnalysisPromptsModule.active}>表示</th>
                <th className={submissionAnalysisPromptsModule.optionContent}>ボタン</th>
                <th className={submissionAnalysisPromptsModule.optionContent}>説明</th>
                <th className={submissionAnalysisPromptsModule.optionContent}>プロンプト</th>
                <th className={submissionAnalysisPromptsModule.active}>保存</th>
              </tr>
            </thead>
            <tbody>
              {submissionAnalysisPrompts.map((submissionAnalysisPrompt, index) => (
                <tr key={index} className={submissionAnalysisPromptsModule['tr-container']}>
                  <td className={submissionAnalysisPromptsModule.active}>
                    <Switch2
                      value={submissionAnalysisPrompt.active}
                      checked={submissionAnalysisPrompt.active}
                      onText={'表示'}
                      offText={'非表示'}
                      onChange={(e) =>
                        changeSubmissionAnalysisPrompts({ active: !submissionAnalysisPrompt.active }, index)
                      }
                    />
                  </td>
                  <td>
                    <textarea
                      value={submissionAnalysisPrompt.buttonTitle}
                      className={submissionAnalysisPromptsModule['option']}
                      onChange={(e) => changeSubmissionAnalysisPrompts({ buttonTitle: e.target.value }, index)}
                    />
                  </td>
                  <td>
                    <textarea
                      value={submissionAnalysisPrompt.description}
                      className={submissionAnalysisPromptsModule['option']}
                      onChange={(e) => changeSubmissionAnalysisPrompts({ description: e.target.value }, index)}
                    />
                  </td>
                  <td>
                    <textarea
                      className={submissionAnalysisPromptsModule['optionContent']}
                      value={submissionAnalysisPrompt.prompt}
                      style={{ imeMode: 'auto' }}
                      onChange={(e) => changeSubmissionAnalysisPrompts({ prompt: e.target.value }, index)}
                    />
                  </td>
                  <td className={submissionAnalysisPromptsModule.active}>
                    <button
                      className={submissionAnalysisPromptsModule['save']}
                      onClick={() => saveSubmissionAnalysisPrompt(submissionAnalysisPrompt)}
                    >
                      保存
                    </button>
                    <button
                      className={submissionAnalysisPromptsModule['delete']}
                      onClick={() => deleteSubmissionAnalysisPrompt(submissionAnalysisPrompt, index)}
                    >
                      削除
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* <button onClick={() => addSubmissionAnalysisPrompt()}>+</button> */}
        <div>
          <AddCircleIcon
            className={submissionAnalysisPromptsModule['addicon']}
            onClick={() => addSubmissionAnalysisPrompt()}
          />
        </div>
      </div>
    </div>
  )
}

export default SubmissionAnalysisPromptsComponent
